import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'customer',
    redirect: '/my-orders' ,
    component: () => import('../components/layouts/panel.vue'),
    // meta:{
    //   pageTitle: 'طلای هنزا گلد',
    // },
    children: [
      {
        path: 'my-orders',
        name:'myOrders',
        component: () => import('../views/Panel_Views/My-Orders.vue')
      },
      {
        path: 'checkout',
        component: () => import('../views/Panel_Views/Checkout.vue')
      },
      {
        path: 'my-transactions',
        component: () => import('../views/Panel_Views/My-Transactions.vue')
      },
      {
        path: 'my-address',
        component: () => import('../views/Panel_Views/My-Address.vue')
      },
      {
        path: 'profile',
        component: () => import('../views/Panel_Views/Profile.vue')
      },
      {
        path: 'dashboard',
        name:'dashboard',
        component: () => import('../views/Panel_Views/dashboard.vue')
      },
      {
        path: 'wish-list',
        component: () => import('../views/Panel_Views/Wish-List.vue')
      },
    ]
  },
  {
    path: '*',
    name: '404',
    component: () => import('../views/Error404.vue')
  },
  {
    path: 'error-500',
    name: '500',
    component: () => import('../views/Error500.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Panel_Views/Register.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Panel_Views/Login.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/*router.afterEach(() => {
  // Remove initial loading
  togglePreLoader('close')
  // Vue.nextTick(() => {
  //   document.title = to.meta.pageTitle || 'طلای هنزا گلد';
  // });
})*/
const noneath = ["/login","/register","/error-404"]
router.beforeEach((to, from, next) => {
  togglePreLoader('open')
  let isLogin = localStorage.getItem('accessToken')|| null
  if (isLogin) {
    if (to.query.innerRoute   || to.query.outerRoute ){
      if (to.query.innerRoute) {
        next(`/${to.query.innerRoute}`)
        togglePreLoader('close')
      }
      else if (to.query.outerRoute){
        window.location.href =  to.query.outerRoute
        togglePreLoader('close')
      }
    }
    else if (to.path === "/login" || to.path === "/register"){
      next('/my-orders')
      togglePreLoader('close')
    }
    else {
      next()
      togglePreLoader('close')
    }
  }
  else{
    if (noneath.includes(to.path)){
      next()
      togglePreLoader('close')
    }
    else {
      console.log('no',to.path)
      next(`/login?innerRoute=${to.path.replace('/', '')}`)
      togglePreLoader('close')
    }
  }
})

function togglePreLoader(flag) {
  const appLoading = document.getElementById('loading-bg')
  if(appLoading){
    if ( flag === "open" && appLoading.classList.contains('hidden')) {
      appLoading.classList.toggle('hidden')
    }
    else if( flag === "close" && !appLoading.classList.contains('hidden')){
      appLoading.classList.toggle('hidden')
    }
  }
}

export default router
